import hasPermi from './permisson/hasPermi'

const install = function(Vue) {
  Vue.directive('hasPermi', hasPermi)
}

export default install
